

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface LabCategoryParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
    
}

export interface LabCategory {
    snomedCode?: number;
    id?: number;
    name: string;
    serviceCategory?: any;
    groupId?:number;
    headCode?:string;
    subHeadCode?:string;
    // add new fields by RAJA
    serviceCategoryId?:any;
    tenantId?: any;
    branchId?: any; 
    isActive?:any;
    code?:any;
sortOrder?:any;
    // Anandhi 13/jan/2023
    seperateQueue?:any;
    costCentreFlag?:any;
    costCentreName?:any;
  accountsGroupDet?: { accountsGroupName?: string };
  accountHeadMstDet?: { name?: string };
  accountSubHeadMstDet?: { name?: string };
  parameters?: LabCategoryParameter[];
  links?: any;
  billingHead?:number;
}

export abstract class LabCategoryData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<LabCategory[]>;
  
  // add new get function by RAJA
  abstract subList(url:string):Observable<LabCategory[]>;

  abstract create(url: string,data: LabCategory): Observable<any>;
  abstract update(url: string,data: LabCategory): Observable<any>;
  abstract delete(url: string): Observable<any>;
}